import { connect } from 'react-redux';

import { Page } from '../../../helbest';
import { _set_catg_id } from '../../../store/actions/login_actions';
import { Drawer } from '../../components';
import Content from '../../components/Home/Content/Content';
import CategoryBar from './CategoryBar/CategoryBar';
import useHome from './useHome';

const Home = ({ Login, reduxSetCategoryId }) => {
  const { layouts, categoryList, activeCategory, setActiveCategory } = useHome(
    Login,
    reduxSetCategoryId
  );

  return (
    <Page
      activeCategory={activeCategory}
      bell
      // cart
      className="page-home"
      drawer={<Drawer />}
      hasHeader
      logo
      showFooter={true}>
      <CategoryBar
        activeCategory={activeCategory}
        categories={categoryList}
        setActiveCategory={setActiveCategory}
        showCatg={true}
        withoutUrl={true}
      />
      <Content className="pad-0" layouts={layouts} />
    </Page>
  );
};

const mapStateToProps = (state) => ({
  Login: state.Login
});

const mapDispatchToProps = (dispatch) => ({
  reduxSetCategoryId: (category_id, category_name) =>
    dispatch(_set_catg_id(category_id, category_name))
});

export default connect(mapStateToProps, mapDispatchToProps)(Home);
